const FORMAT_TAGS = {
  B: 'b',
  STRONG: 'b',
  I: 'i',
  EM: 'i',
  U: 'u',
  S: 's',
  STRIKE: 's',
  DEL: 's',
};

function escapeText(value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function serializeComposer(root) {
  let out = '';

  const walk = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      out += escapeText(node.textContent || '');
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    const name = node.nodeName;
    if (name === 'BR') {
      out += '\n';
      return;
    }

    const isBlock = name === 'DIV' || name === 'P';
    if (isBlock && out.length > 0 && !out.endsWith('\n')) out += '\n';

    const tag = FORMAT_TAGS[name];
    if (tag) out += `<${tag}>`;
    node.childNodes.forEach(walk);
    if (tag) out += `</${tag}>`;
  };

  root.childNodes.forEach(walk);
  return out.replace(/<(b|i|u|s)>\s*<\/\1>/g, '').replace(/^\s+|\s+$/g, '');
}

export function hasRichMarkup(text) {
  return /<(b|strong|i|em|u|s|strike)\b/i.test(text || '');
}
